import { render } from "./FormularioRegistrarse .vue?vue&type=template&id=50f22b78&scoped=true"
import script from "./FormularioRegistrarse .vue?vue&type=script&lang=js"
export * from "./FormularioRegistrarse .vue?vue&type=script&lang=js"

import "./FormularioRegistrarse .vue?vue&type=style&index=0&id=50f22b78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f22b78"]])

export default __exports__